import { render } from "./Tele.vue?vue&type=template&id=c9e186fc&scoped=true"
import script from "./Tele.vue?vue&type=script&lang=js"
export * from "./Tele.vue?vue&type=script&lang=js"

import "./Tele.vue?vue&type=style&index=0&id=c9e186fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e186fc"]])

export default __exports__